import type { InsuranceDto } from '@b-stock/shipment-api-client'

/**
 * Estimate of the mandatory parcel shipping-insurance charge, disclosed in the
 * bid/buy confirmation flows before the buyer commits. The actual premium is
 * quoted at order time; this is a pre-commit estimate only.
 *
 * `ratePct`% of the bid capped at `coverageLimit`, rounded half-up to the cent,
 * and never less than `minimumPremium`. Everything is in integer cents, so
 * `Math.round` rounds half-up — matching the backend `buildBuyersPremiumLine`.
 */
export const calculateInsuranceEstimateCents = (
  insurance: Pick<InsuranceDto, 'ratePct' | 'coverageLimit' | 'minimumPremium'>,
  bidCents: number
): number => {
  const basisCents = Math.min(bidCents, insurance.coverageLimit)
  return Math.max(
    insurance.minimumPremium ?? 0,
    Math.round((insurance.ratePct / 100) * basisCents)
  )
}
